<template>
  <div class="search__results">
    <div v-if="!loading">
      <div
        v-for="(item, index) in articles"
        :key="index"
        class="resultBox"
      >
        <div class="resultBox__category">
          <!-- <div
            :class="'categoryIcon--icon-grosse-' + item.categoryslug"
            class="resultBox__categoryIcon categoryIcon categoryIcon--smaller"
          ></div> -->
          {{ item.category }}
        </div>
        <h3 class="resultBox__title">
          <a
            :href="item.permalink"
            v-html="item.title"
          ></a>
        </h3>
        <div class="resultBox__excerpt" v-html="item.excerpt"></div>
        <a class="resultBox__link link" :href="item.permalink">
          {{ readMoreText }}
        </a>
      </div>
    </div>
    <div v-if="loading" class="resultBox__loader">
      <div class="loader">
        Loading...
      </div>
    </div>
    <div
      v-if="mehrVisible"
      class="resultBox__more"
    >
      <a
        class="button button--big button--icon"
        :class="{ 'button--disabled': loading }"
        @click.prevent="loadMore()">
        {{ moreText }}
      </a>
    </div>
  </div>
</template>

<script>


export default {
  props:
  {
    loading: {
      type: Boolean,
      default: false,
    },
    mehrVisible: {
      type: Boolean,
      default: false,
    },
    articles: {
      type: Array,
      default: null,
    },
    moreText: {
      type: String,
      default: 'show more',
    },
    readMoreText: {
      type: String,
      default: 'read more',
    },
  },
  data() {
    return {
      // posts: null,
    };
  },
  mounted()
  {
    // console.log('search results lister - mounted');
  },
  methods: {
    loadMore()
    {
      this.$emit('load-more');
    },
  },
};

</script>

<style scoped lang="scss">
</style>
